import * as React from 'react';

import EventTracking from 'lib/EventTracking';
import { Mutation, Query } from 'react-apollo';
import ToastActions from 'actions/ToastActions';
import AdminEngagementReport from 'admin/engagementReports/components/AdminEngagementReport';
import SEND_ENGAGEMENT_REPORTS from 'admin/engagementReports/mutations/SendEngagementReports.gql';
import GET_ENGAGEMENT_REPORT_WEEKS from 'admin/engagementReports/queries/GetEngagementReportWeeks.gql';
import {
  SendEngagementReports,
  SendEngagementReportsVariables,
} from 'admin/engagementReports/mutations/__generated__/SendEngagementReports';
import {
  GetEngagementReportWeeks,
  GetEngagementReportWeeksVariables,
} from 'admin/engagementReports/queries/__generated__/GetEngagementReportWeeks';

type Props = {
  orgUuid: string;
  paid: boolean;
  eventPrefix: string;
};

type State = {
  week: string;
  submitDisabled: boolean;
};

export default class AdminEngagementReportContainer extends React.Component<Props, State> {
  state: State = {
    week: '',
    submitDisabled: false,
  };

  componentEventPrefix = `${this.props.eventPrefix}.admin_engagement_reports`;

  trackEvent = (key: string, properties: { [key: string]: any } = {}) => {
    EventTracking.trackKey(`${this.componentEventPrefix}.${key}`, properties);
  };

  selectWeek = (week: string) => {
    this.setState({ week });
    this.trackEvent('select_week', { week: this.state.week });
  };

  render() {
    const { orgUuid, paid } = this.props;

    return (
      <Mutation<SendEngagementReports, SendEngagementReportsVariables>
        mutation={SEND_ENGAGEMENT_REPORTS}
        onCompleted={() => {
          ToastActions.showSuccessToast(
            'You’ll receive an email shortly with the engagement report.'
          );

          this.setState({ submitDisabled: false });
        }}
        onError={error => {
          ToastActions.showErrorToast(error.message);

          this.setState({ submitDisabled: false });
        }}>
        {sendEngagementReports => {
          return (
            <Query<GetEngagementReportWeeks, GetEngagementReportWeeksVariables>
              query={GET_ENGAGEMENT_REPORT_WEEKS}
              variables={{ orgUuid }}>
              {({ loading, data }) => {
                const weeks = data?.engagementReports?.reportWeeks || [];

                if (weeks.length && this.state.week !== weeks[0]) {
                  this.selectWeek(weeks[0]);
                }

                return (
                  <AdminEngagementReport
                    orgUuid={orgUuid}
                    weeks={weeks}
                    selected={this.state.week}
                    submitDisabled={loading || this.state.submitDisabled || !paid}
                    eventPrefix={this.componentEventPrefix}
                    selectWeek={this.selectWeek}
                    sendEngagementReport={() => {
                      this.trackEvent('select_report_week', {
                        selected: this.state.week,
                        orgUuid: this.props.orgUuid,
                      });

                      this.setState({ submitDisabled: true });

                      sendEngagementReports({
                        variables: { input: { orgUuid, weeks: [this.state.week] } },
                      });
                    }}
                  />
                );
              }}
            </Query>
          );
        }}
      </Mutation>
    );
  }
}
